import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Checkbox from './checkbox.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'control', 'label', 'icon'];
function baseStyleControl(props) {
  var _Checkbox$baseStyle = Checkbox.baseStyle(props),
    control = _Checkbox$baseStyle.control;
  return _objectSpread(_objectSpread({}, control), {}, {
    borderRadius: 'full',
    _checked: _objectSpread({}, control._checked)
  });
}
var baseStyle = function baseStyle(props) {
  return {
    label: Checkbox.baseStyle(props).label,
    control: baseStyleControl(props),
    icon: Checkbox.baseStyle(props).icon
  };
};
var sizes = {
  sm: {
    control: {
      width: 3.5,
      height: 3.5
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: 'xs'
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: 'lg'
    },
    icon: {
      fontSize: 'xs'
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'xl'
    },
    icon: {
      fontSize: 'xs'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var Radio = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Radio as default };